import styled from 'styled-components';
import { colors } from '@omilia/theme';
import { Text } from '@omilia/typography';
import Icon from '@omilia/icon';

export const SButton = styled.button`
  background-color: ${colors.COLOR_WHITE};
  border: 1px solid ${colors.COLOR_GREY_400};
  border-radius: 6px;
  display: block;
  flex-grow: 1;
  height: 146px;
  margin-right: 20px;
  text-align: center;
  width: 146px;

  &:active {
    background-color: ${colors.COLOR_BLUE_600};
  }

  &:hover {
    background-color: ${colors.COLOR_BLUE_100};
    border: 1px solid ${colors.COLOR_BLUE_600};
  }

  &:last-of-type {
    margin-right: 0;
  }
`;

export const SModalDescription = styled(Text)`
  color: ${colors.COLOR_GREY_1000};
  margin-bottom: 16px;
`;

export const SModalBody = styled.div`
  display: flex;
  margin-bottom: 24px;
`;

export const SModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SIcon = styled(Icon)`
  margin-top: 32px;
`;

export const SIconWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-items: center;
`;

export const SIconText = styled(Text)`
  color: ${colors.COLOR_BLUE_600};
  margin-bottom: 32px;
  margin-top: 14px;
`;
